function toggleAccountOwnerAttributes(supports_account_owner_attributes) {
  if (supports_account_owner_attributes) {
    $('#account_owner_attributes_section').removeClass('hidden');
  } else {
    $('#account_owner_attributes_section').addClass('hidden');
  }
}

var AccountOwnerAttributes = {
  toggleAccountOwnerAttributes: toggleAccountOwnerAttributes
};
export default AccountOwnerAttributes;